// extracted by mini-css-extract-plugin
module.exports = {"activity":"styles_activity__3OuXa","kaart":"styles_kaart__ZshIT","kaartContainer":"styles_kaartContainer__3DxPL","vaaContent":"styles_vaaContent__3wCgV"};